import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "./CurrentOpenPosition.css";
import Testimonial from "../../../Testimonial/Testimonial";

const CurrentOpenPosition = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1;

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  const [activeFilter, setActiveFilter] = useState("all");

  const jobPositions = [
    {
      id: 1,
      title: "Senior Frontend Developer",
      department: "Engineering",
      type: "Full-time",
      location: "Remote",
      description:
        "We're looking for an experienced frontend developer with React expertise to join our growing team.",
      requirements: [
        "5+ years experience",
        "React, JavaScript, HTML/CSS",
        "State management",
        "Testing frameworks",
      ],
      isNew: true,
    },
    {
      id: 2,
      title: "DevOps Engineer",
      department: "Operations",
      type: "Full-time",
      location: "New York, NY",
      description:
        "Join our infrastructure team to build and maintain our cloud-based systems.",
      requirements: [
        "AWS/Azure experience",
        "Kubernetes & Docker",
        "CI/CD pipelines",
        "Infrastructure as Code",
      ],
      isNew: false,
    },
    {
      id: 3,
      title: "UX/UI Designer",
      department: "Design",
      type: "Full-time",
      location: "San Francisco, CA",
      description:
        "Create beautiful and intuitive user experiences for our enterprise software products.",
      requirements: [
        "Portfolio required",
        "Figma/Sketch expertise",
        "User research experience",
        "Prototyping skills",
      ],
      isNew: true,
    },
    {
      id: 4,
      title: "Backend Developer",
      department: "Engineering",
      type: "Full-time",
      location: "Remote",
      description:
        "Design and implement scalable backend services for our platform.",
      requirements: [
        "Node.js/Python/Java",
        "Database design",
        "API development",
        "Microservices architecture",
      ],
      isNew: false,
    },
    {
      id: 5,
      title: "Product Manager",
      department: "Product",
      type: "Full-time",
      location: "Boston, MA",
      description: "Lead product initiatives from conception to launch.",
      requirements: [
        "5+ years PM experience",
        "Technical background",
        "Agile methodologies",
        "Data-driven decision making",
      ],
      isNew: false,
    },
    {
      id: 6,
      title: "Data Scientist",
      department: "Data",
      type: "Contract",
      location: "Remote",
      description:
        "Help derive insights from our large datasets to inform product decisions.",
      requirements: [
        "ML algorithms",
        "Python/R",
        "Statistical analysis",
        "Data visualization",
      ],
      isNew: true,
    },
    {
      id: 7,
      title: "Cloud Solutions Architect",
      department: "Engineering",
      type: "Full-time",
      location: "Austin, TX",
      description:
        "Design and implement cloud infrastructure solutions for enterprise clients.",
      requirements: [
        "AWS/Azure/GCP certification",
        "10+ years IT experience",
        "Solution design",
        "Security best practices",
      ],
      isNew: true,
    },
    {
      id: 8,
      title: "Technical Project Manager",
      department: "Operations",
      type: "Full-time",
      location: "Chicago, IL",
      description:
        "Oversee complex technical projects from initiation to delivery.",
      requirements: [
        "PMP certification preferred",
        "Agile/Scrum mastery",
        "Risk management",
        "Team leadership",
      ],
      isNew: false,
    },
    {
      id: 9,
      title: "Mobile App Developer",
      department: "Engineering",
      type: "Full-time",
      location: "Seattle, WA",
      description:
        "Build innovative mobile applications for iOS and Android platforms.",
      requirements: [
        "React Native/Flutter",
        "Native iOS/Android development",
        "RESTful APIs",
        "App Store deployment",
      ],
      isNew: false,
    },
    {
      id: 10,
      title: "Technical Writer",
      department: "Documentation",
      type: "Part-time",
      location: "Remote",
      description:
        "Create clear and comprehensive documentation for our software products.",
      requirements: [
        "Technical background",
        "Exceptional writing skills",
        "API documentation",
        "Diagrams and visuals",
      ],
      isNew: true,
    },
    {
      id: 11,
      title: "QA Automation Engineer",
      department: "Engineering",
      type: "Full-time",
      location: "Remote",
      description:
        "Develop and maintain automated testing frameworks for our products.",
      requirements: [
        "Selenium/Cypress",
        "Test planning",
        "CI/CD integration",
        "Bug tracking",
      ],
      isNew: false,
    },
    {
      id: 12,
      title: "IT Support Specialist",
      department: "Operations",
      type: "Full-time",
      location: "Miami, FL",
      description:
        "Provide technical support to our internal teams and clients.",
      requirements: [
        "Troubleshooting skills",
        "Hardware/software knowledge",
        "Customer service",
        "Ticketing systems",
      ],
      isNew: false,
    },
    {
      id: 13,
      title: "Machine Learning Engineer",
      department: "Data",
      type: "Full-time",
      location: "Remote",
      description:
        "Design and implement machine learning models to solve complex problems.",
      requirements: [
        "TensorFlow/PyTorch",
        "Data preprocessing",
        "Model evaluation",
        "MLOps experience",
      ],
      isNew: true,
    },
    {
      id: 14,
      title: "Sales Engineer",
      department: "Sales",
      type: "Full-time",
      location: "Los Angeles, CA",
      description:
        "Bridge the gap between technical teams and clients during the sales process.",
      requirements: [
        "Technical presentation skills",
        "Product demonstration",
        "Client relationship management",
        "Solution design",
      ],
      isNew: false,
    },
    {
      id: 15,
      title: "Scrum Master",
      department: "Operations",
      type: "Full-time",
      location: "Denver, CO",
      description:
        "Facilitate agile processes and help teams deliver value efficiently.",
      requirements: [
        "CSM/PSM certification",
        "Agile coaching",
        "Conflict resolution",
        "Metrics tracking",
      ],
      isNew: true,
    },
    {
      id: 16,
      title: "Full Stack Developer",
      department: "Engineering",
      type: "Full-time",
      location: "Remote",
      description:
        "Develop end-to-end web applications with both frontend and backend technologies.",
      requirements: [
        "JavaScript/TypeScript",
        "Node.js/Express",
        "React/Angular/Vue",
        "Database management",
      ],
      isNew: true,
    },
    {
      id: 17,
      title: "Full Stack MERN Developer",
      department: "Engineering",
      type: "Full-time",
      location: "Remote",
      description:
        "Specialize in MongoDB, Express.js, React, and Node.js stack for full stack development.",
      requirements: [
        "MongoDB expertise",
        "Express.js framework",
        "React.js proficiency",
        "Node.js development",
      ],
      isNew: true,
    },
    {
      id: 18,
      title: "Full Stack MEAN Developer",
      department: "Engineering",
      type: "Full-time",
      location: "Remote",
      description:
        "Develop applications using MongoDB, Express.js, Angular, and Node.js stack.",
      requirements: [
        "MongoDB database skills",
        "Express.js backend",
        "Angular framework",
        "Node.js runtime",
      ],
      isNew: true,
    },
    {
      id: 19,
      title: "Java Developer",
      department: "Engineering",
      type: "Full-time",
      location: "Remote",
      description:
        "Build robust and scalable applications using Java technologies.",
      requirements: [
        "Java 8+",
        "Spring/Spring Boot",
        "RESTful APIs",
        "Microservices architecture",
      ],
      isNew: false,
    },
    {
      id: 20,
      title: "Web Developer",
      department: "Engineering",
      type: "Full-time",
      location: "Remote",
      description:
        "Create responsive and interactive websites and web applications.",
      requirements: [
        "HTML5/CSS3",
        "JavaScript/jQuery",
        "Responsive design",
        "Cross-browser compatibility",
      ],
      isNew: false,
    },
    {
      id: 21,
      title: "Digital Marketing Specialist",
      department: "Marketing",
      type: "Full-time",
      location: "Remote",
      description:
        "Develop and implement digital marketing strategies to increase brand awareness.",
      requirements: [
        "SEO/SEM",
        "Social media marketing",
        "Google Analytics",
        "Content strategy",
      ],
      isNew: true,
    },
    {
      id: 22,
      title: "AWS Cloud Engineer",
      department: "Engineering",
      type: "Full-time",
      location: "Remote",
      description:
        "Design, deploy, and maintain applications on AWS cloud infrastructure.",
      requirements: [
        "AWS services (EC2, S3, Lambda)",
        "CloudFormation/Terraform",
        "Serverless architecture",
        "Security best practices",
      ],
      isNew: true,
    },
    {
      id: 23,
      title: "Cloud Security Specialist",
      department: "Security",
      type: "Full-time",
      location: "Remote",
      description:
        "Ensure the security of our cloud infrastructure and applications.",
      requirements: [
        "Cloud security best practices",
        "Identity and access management",
        "Security compliance",
        "Threat detection",
      ],
      isNew: true,
    },
    // NEWLY ADDED POSITIONS
    {
      id: 24,
      title: "AI/ML Research Scientist",
      department: "Research",
      type: "Full-time",
      location: "Remote",
      description:
        "Conduct cutting-edge research in artificial intelligence and machine learning.",
      requirements: [
        "PhD in Computer Science or related field",
        "Publications in top AI conferences",
        "Deep learning frameworks",
        "Research methodology",
      ],
      isNew: true,
    },
    {
      id: 25,
      title: "Blockchain Developer",
      department: "Engineering",
      type: "Full-time",
      location: "Remote",
      description:
        "Develop decentralized applications and smart contracts on blockchain platforms.",
      requirements: [
        "Solidity/Rust",
        "Ethereum/Polkadot",
        "Smart contract development",
        "Web3.js/Ethers.js",
      ],
      isNew: true,
    },
    {
      id: 26,
      title: "Cybersecurity Analyst",
      department: "Security",
      type: "Full-time",
      location: "Remote",
      description:
        "Protect our systems and networks from cyber threats and vulnerabilities.",
      requirements: [
        "Security monitoring tools",
        "Incident response",
        "Vulnerability assessment",
        "Security frameworks",
      ],
      isNew: false,
    },
    {
      id: 27,
      title: "Data Engineer",
      department: "Data",
      type: "Full-time",
      location: "Remote",
      description:
        "Design and build data pipelines and infrastructure for big data processing.",
      requirements: [
        "Apache Spark/Hadoop",
        "ETL processes",
        "Data warehousing",
        "SQL/NoSQL databases",
      ],
      isNew: true,
    },
    {
      id: 28,
      title: "ERP Consultant",
      department: "Business Solutions",
      type: "Full-time",
      location: "Remote",
      description:
        "Implement and customize ERP solutions for enterprise clients.",
      requirements: [
        "SAP/Oracle/NetSuite experience",
        "Business process analysis",
        "System configuration",
        "Client training",
      ],
      isNew: false,
    },
    {
      id: 29,
      title: "Game Developer",
      department: "Engineering",
      type: "Full-time",
      location: "Remote",
      description:
        "Create engaging and interactive gaming experiences across multiple platforms.",
      requirements: [
        "Unity/Unreal Engine",
        "C++/C#",
        "3D graphics programming",
        "Game physics",
      ],
      isNew: true,
    },
    {
      id: 30,
      title: "IT Auditor",
      department: "Compliance",
      type: "Full-time",
      location: "Remote",
      description:
        "Evaluate and improve the effectiveness of IT controls and processes.",
      requirements: [
        "CISA certification",
        "Risk assessment",
        "Control testing",
        "Audit reporting",
      ],
      isNew: false,
    },
    {
      id: 31,
      title: "Network Engineer",
      department: "Operations",
      type: "Full-time",
      location: "Remote",
      description:
        "Design, implement, and maintain network infrastructure and systems.",
      requirements: [
        "Cisco/Juniper certifications",
        "TCP/IP networking",
        "Network security",
        "Troubleshooting skills",
      ],
      isNew: true,
    },
    {
      id: 32,
      title: "Python Developer",
      department: "Engineering",
      type: "Full-time",
      location: "Remote",
      description:
        "Develop applications and services using Python programming language.",
      requirements: [
        "Python frameworks (Django/Flask)",
        "RESTful APIs",
        "Database integration",
        "Testing frameworks",
      ],
      isNew: false,
    },
    {
      id: 33,
      title: "SEO Specialist",
      department: "Marketing",
      type: "Full-time",
      location: "Remote",
      description:
        "Optimize website content and structure to improve search engine rankings.",
      requirements: [
        "Keyword research",
        "On-page/off-page SEO",
        "Analytics tools",
        "Content strategy",
      ],
      isNew: true,
    },
  ];

  const filters = [
    { key: "all", label: "All Positions" },
    { key: "Engineering", label: "Engineering" },
    { key: "Design", label: "Design" },
    { key: "Product", label: "Product" },
    { key: "Data", label: "Data" },
    { key: "Operations", label: "Operations" },
    { key: "Security", label: "Security" },
    { key: "Documentation", label: "Documentation" },
    { key: "Sales", label: "Sales" },
    { key: "Marketing", label: "Marketing" },
    { key: "Research", label: "Research" },
    { key: "Business Solutions", label: "Business Solutions" },
    { key: "Compliance", label: "Compliance" },
  ];

  const filteredPositions =
    activeFilter === "all"
      ? jobPositions
      : jobPositions.filter((job) => job.department === activeFilter);

  // Function to handle WhatsApp application
  const applyViaWhatsApp = (position) => {
    // Format the message with job details
    const message = `Hello MK E-Tech Team,\n\nI am interested in applying for the ${position.title} position.\n\nPlease provide more details about the application process.\n\nI will send my resume shortly.`;

    // Encode the message for URL
    const encodedMessage = encodeURIComponent(message);

    // Create WhatsApp URL
    const whatsappURL = `https://wa.me/919155599968?text=${encodedMessage}`;

    // Open WhatsApp in a new tab
    window.open(whatsappURL, "_blank");
  };

  return (
    <div>
      {/* ✅ Helmet Meta Tags */}
      <Helmet>
        <title>
          Current Open Positions | Careers in IT & Emerging Technologies
        </title>
        <meta
          name="description"
          content="Explore current open positions and technologies we work with, including AI, Blockchain, Cloud, Data Science, Web Development, and more. Join our team and grow your career with cutting-edge tools & tech stack."
        />
        <meta
          name="keywords"
          content="Current Open Positions, Careers in IT, Jobs in AI, Blockchain Careers, Data Science Jobs, Cloud Computing Careers, Web Development Jobs, Angular Jobs, React Native Jobs, Laravel Jobs, PHP Jobs, Node.js Jobs, SQL Jobs, MongoDB Careers, Virtual Reality Jobs, Augmented Reality Careers, IoT Jobs, Artificial Intelligence Careers, Ethereum Blockchain Jobs, Hyperledger Careers, Flutter Jobs"
        />
      </Helmet>
      <div className="mk-eteck-careers">
        <section className="mk-careers-hero">
          <div className="mk-hero-content">
            <h1 className="mk-hero-title-job">
              Join Our <span className="mk-text-gradient">Innovative</span> Team
            </h1>
            <p className="mk-hero-subtitle-job">
              Help us shape the future of technology while growing your career
              at a leading IT software company.
            </p>
          </div>
          <div className="mk-hero-animation">
            <div className="mk-animation-circle mk-circle-1"></div>
            <div className="mk-animation-circle mk-circle-2"></div>
            <div className="mk-animation-circle mk-circle-3"></div>
          </div>
        </section>

        <section className="mk-careers-content">
          <div className="mk-container">
            <div className="mk-section-header">
              <h2>Current Open Positions</h2>
              <p>Explore opportunities to join our talented team</p>
            </div>

            <div className="mk-filters">
              {filters.map((filter) => (
                <button
                  key={filter.key}
                  className={`mk-filter-btn ${
                    activeFilter === filter.key ? "mk-active" : ""
                  }`}
                  onClick={() => setActiveFilter(filter.key)}
                >
                  {filter.label}
                </button>
              ))}
            </div>

            <div className="mk-positions-grid">
              {filteredPositions.map((position) => (
                <div key={position.id} className="mk-position-card">
                  {position.isNew && <span className="mk-new-badge">New</span>}
                  <h3 className="mk-position-title">{position.title}</h3>
                  <div className="mk-position-meta">
                    <span className="mk-position-dept">
                      {position.department}
                    </span>
                    <span className="mk-position-type">{position.type}</span>
                    <span className="mk-position-location">
                      {position.location}
                    </span>
                  </div>
                  <p className="mk-position-desc">{position.description}</p>
                  <div className="mk-position-requirements">
                    <h4>Requirements:</h4>
                    <ul>
                      {position.requirements.map((req, index) => (
                        <li key={index}>{req}</li>
                      ))}
                    </ul>
                  </div>
                  <button
                    className="mk-apply-btn"
                    onClick={() => applyViaWhatsApp(position)}
                  >
                    Apply Via WhatsApp
                  </button>
                </div>
              ))}
            </div>

            {filteredPositions.length === 0 && (
              <div className="mk-no-positions">
                <h3>No positions available in this category</h3>
                <p>Please check back later or explore other categories</p>
              </div>
            )}
          </div>
        </section>
      </div>
      <Testimonial />

      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentOpenPosition;
